import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'
import { LearnMoreNavigation } from 'modules/upselling_kit/types'

export const MissingFeatureEmptyState = ({
  requestSource,
  learnMoreNavigate,
  description,
  featureRequested,
  variant = 'page',
}: {
  requestSource: string
  featureRequested: Features
  description: string
  learnMoreNavigate?: string | LearnMoreNavigation
  variant?: 'page' | 'card' | 'table'
}) => {
  return (
    <UpsellingKit.EmptyState
      moduleRequested={AvailableModules.projects}
      featureRequested={featureRequested}
      requestReason={ValidReasons.MissingFeature}
      requestSource={requestSource}
      title={i18n.t('project_management.upselling.title')}
      description={description}
      buttonLabel={i18n.t('project_management.upselling.cta')}
      learnMoreNavigate={learnMoreNavigate}
      variant={variant}
    />
  )
}
